'use strict';
var actionTypes = require('./actionTypes');
let client = require('../../sdk/client.js')
if (typeof window !== 'undefined') {
    var $ = window.$;
}

function searchPurchase(filters) {
    return function (dispatch, getState) {
        let keyword = getState().purchaseReducer.keyword;
        let suppliers = getState().purchaseReducer.selectedSuppliers;
        let status = getState().purchaseReducer.selectedOrderStatuses;
        let date = getState().purchaseReducer.selectedDates;
        let cartItemStatus = getState().purchaseReducer.selectedCartItemStatus
        if (!filters.supplier) {
            filters.supplier = suppliers;
        }
        if (!filters.status) {
            filters.status = status;
        }
        if (!filters.keyword) {
            filters.keyword = keyword;
            if (!filters.keyword) {
                filters.keyword = $("#keywords").val();
            }
        }
        if (!filters.startDate) {
            filters.startDate = date.StartDate;
            filters.endDate = date.EndDate;
        }
        if (!filters.pageNumber) {
            //should go to page1 for changing of pageSize
            filters.pageNumber = 1;
        }
        if (!filters.cartItemFulfilmentStatuses) {
            filters.cartItemFulfilmentStatuses = cartItemStatus;
        }
        $.ajax({
            url: '/purchase/history/search',
            type: 'GET',
            data: {
                keyword: filters.keyword,
                startDate: filters.startDate,
                endDate: filters.endDate,
                supplier: filters.supplier,
                status: filters.status,
                cartItemFulfilmentStatuses: filters.cartItemFulfilmentStatuses,
                pageNumber: 1,
                pageSize: filters.pageSize

            },
            success: function (history) {
                return dispatch({
                    type: actionTypes.FETCH_PURCHASES,
                    history: history
                });
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.log(textStatus, errorThrown);
            }
        });
    };
}

function searchPurchaseFulfilment(filters) {
    return function (dispatch, getState) {
        let keyword = getState().purchaseReducer.keyword;
        let suppliers = getState().purchaseReducer.selectedSuppliers;
        let status = getState().purchaseReducer.selectedOrderStatuses;
        let date = getState().purchaseReducer.selectedDates;
        let cartItemStatus = getState().purchaseReducer.selectedCartItemStatus
        if (!filters.supplier) {
            filters.supplier = suppliers;
        }
        if (!filters.status) {
            filters.status = status;
        }
        if (!filters.keyword) {
            filters.keyword = keyword;
            if (!filters.keyword) {
                filters.keyword = $("#keywords").val();
            }
        }
        if (!filters.startDate) {
            filters.startDate = date.StartDate;
            filters.endDate = date.EndDate;
        }
        if (!filters.pageNumber) {
            //should go to page1 for changing of pageSize
            filters.pageNumber = 1;
        }
        if (!filters.cartItemFulfilmentStatuses) {
            filters.cartItemFulfilmentStatuses = cartItemStatus;
        }
        let userID = filters.userID;
        const promiseItems = new Promise((resolve, reject) => {
            client.Transactions.getTransactionsByBuyerFulfilment(userID, 20, 1, filters.keyword, filters.startDate, filters.endDate, filters.status, function (err, result) {
                   resolve(result);                               
                });
            });
    
            Promise.all([promiseItems]).then(response=>{ 
                $.unblockUI();
                return dispatch({
                    type: actionTypes.FETCH_PURCHASES,
                    history: response[0]
                });
            });
    };
}
var globalFlag = 0;
function goToPageN(page, userId) {
    // console.log(page);
    // console.log(userId);
    
    if(page != "page") {
        console.log('Flag ' + globalFlag);
        if (typeof window !== 'undefined') {
            const queryString = window.location.search
            const urlParams = new URLSearchParams(queryString);
            const pagination = urlParams.get('pagination');
            console.log("Pagination arrived: " + pagination);
            goToPage(pagination)
/*
            globalFlag = 1;
            window.history.replaceState("data", "title", "/purchase/history");
            var pageSearched = page - 1;
            setTimeout(function(){
                console.log('click');
                if(page < 6) {
                    document.getElementsByClassName('pagination')[0].getElementsByClassName('numeros')[pageSearched].getElementsByTagName('a')[0].click();
                    window.history.replaceState("data", "title", "/purchase/history");
                } else {
                    document.getElementsByClassName('pagination')[0].getElementsByClassName('numeros')[6].getElementsByTagName('a')[0].click();
                    window.history.replaceState("data", "title", "/purchase/history");
                    setTimeout(function(){
                        var elec = 0;
                        var options = document.getElementsByClassName('pagination')[0].getElementsByClassName('numeros');

                        for(var i=0; i<options.length; i++){
                            if(elec == 0) {
                                if(options[i].innerText == page) {
                                    options[pageSearched].getElementsByTagName('a')[0].click();
                                    options[pageSearched].className = "numbers active";
                                    elec = 1;
                                }
                            }
                        }

                        setTimeout(function(){
                            if(elec == 0) {
                                document.getElementsByClassName('pagination')[0].getElementsByClassName('numeros')[2].getElementsByTagName('a')[0].click();
                                options = document.getElementsByClassName('pagination')[0].getElementsByClassName('numeros');

                                for(var i=0; i<options.length; i++){
                                    if(elec == 0) {
                                        console.log(options[i].innerText + " " + page)
                                        if(options[i].innerText == page) {
                                            setTimeout(function(index){
                                                console.log('final click');
                                                var options2 = document.getElementsByClassName('pagination')[0].getElementsByClassName('numeros');
                                                for(var j=0; j<options2.length; j++){
                                                    if(options2[j].innerText == page) {
                                                        options2[j-1].className = "numbers active";
                                                        options2[j-1].getElementsByTagName('a')[0].click();
                                                    }
                                                }
                                                elec = 1;
                                            }.bind(this, i), 2000);
                                        }
                                    }
                                }
                            }
                            setTimeout(function(){
                                if(elec == 0) {
                                    setTimeout(function(){
                                        options = document.getElementsByClassName('pagination')[0].getElementsByClassName('numeros');
                                        console.log(options.length);
                                        for(var i=0; i<options.length; i++){
                                            if(elec == 0) {
                                                console.log("sec " + options[i].innerText + " " + page)
                                                if(options[i].innerText == page) {
                                                    console.log('final click 2 ' + options[i].innerText + " " + page);
                                                    setTimeout(function(index){
                                                        console.log('clicking');
                                                        var options2 = document.getElementsByClassName('pagination')[0].getElementsByClassName('numeros');
                                                        for(var j=0; j<options2.length; j++){
                                                            if(options2[j].innerText == page) {
                                                                console.log("f: " + options2[j].innerText + " " + page);
                                                                options2[j-1].className = "numbers active";
                                                                options2[j-1].getElementsByTagName('a')[0].click();
                                                            }
                                                        }
                                                        elec = 1;
                                                    }.bind(this, i), 2000);
                                                }
                                            }
                                        }
                                    }, 5000);
                                }
                            }, 2000);
                        }, 2000);
                        /*
                        if(document.getElementsByClassName('pagination')[0].getElementsByClassName('numeros').length > 8) {
                            document.getElementsByClassName('pagination')[0].getElementsByClassName('numeros')[pageSearched-1].getElementsByTagName('a')[0].click();
                        } else if(document.getElementsByClassName('pagination')[0].getElementsByClassName('numeros').length == 7 && document.getElementsByClassName('pagination')[0].getElementsByClassName('numeros')[6].innerText == '11'){
                            document.getElementsByClassName('pagination')[0].getElementsByClassName('numeros')[pageSearched-5].getElementsByTagName('a')[0].click();
                        } else if(document.getElementsByClassName('pagination')[0].getElementsByClassName('numeros').length == 7 && document.getElementsByClassName('pagination')[0].getElementsByClassName('numeros')[6].innerText == '10'){
                            document.getElementsByClassName('pagination')[0].getElementsByClassName('numeros')[pageSearched-4].getElementsByTagName('a')[0].click();
                        }
                        
                    }, 2000);
                }
            }, 3000);
            */
        }
    }
} 

function goToPage(pageNumber, filters) {
    return function (dispatch, getState) {
        let keyword = getState().purchaseReducer.keyword;
        let pageSize = getState().purchaseReducer.history.PageSize;
        let suppliers = getState().purchaseReducer.selectedSuppliers;
        let status = getState().purchaseReducer.selectedOrderStatuses;
        let date = getState().purchaseReducer.selectedDates;

        let startDate = "";
        let endDate = "";
        if (date) {
            startDate = date.StartDate;
            endDate = date.EndDate;
        }

        if (!keyword) {
            keyword = $("#keywords").val();
        }

        $.ajax({
            url: '/purchase/history/search',
            type: 'GET',
            data: {
                keyword: keyword,
                pageNumber: pageNumber,
                pageSize: pageSize,
                supplier: suppliers,
                startDate: startDate,
                endDate: endDate,
                status: status
            },
            success: function (history) {
                return dispatch({
                    type: actionTypes.GO_TO_PAGE,
                    history: history
                });
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.log(textStatus, errorThrown);
            }
        });
    };
}

function goToPageFulfilment(pageNumber, userId) {
    $.blockUI({ css: { backgroundColor: '#D1D2D4'}, message: 'Cambiando página, por favor espere.'});
    console.log("1 a");

    return function (dispatch, getState) {
        let keyword = getState().purchaseReducer.keyword;
        let pageSize = getState().purchaseReducer.history.PageSize;
        let suppliers = getState().purchaseReducer.selectedSuppliers;
        let status = getState().purchaseReducer.selectedOrderStatuses;
        let date = getState().purchaseReducer.selectedDates;
        console.log("2 a");

        let startDate = "";
        let endDate = "";
        if (date) {
            startDate = date.StartDate;
            endDate = date.EndDate;
        }

        if (!keyword) {
            keyword = $("#keywords").val();
        }
        window.history.replaceState("data", "title", "/purchase/history?pagination=" + pageNumber);

        //                                                          //user y page number vienen de llamada de funcion
        //                                                          //keyword, startDate, endDate y status vienen de la store de la pagina, previamente declarados
        const promiseItems = new Promise((resolve, reject) => {
            client.Transactions.getTransactionsByBuyerFulfilment(userId, 20, pageNumber, keyword, startDate, endDate, status, function (err, result) {
                   resolve(result);                               
                });
            });
            window.history.replaceState("data", "title", "/purchase/history?pagination=" + pageNumber);

            Promise.all([promiseItems]).then(response=>{ 
                $.unblockUI();
                window.history.replaceState("data", "title", "/purchase/history?pagination=" + pageNumber);
                //document.getElementById("paginationNo").value = pageNumber;
            
                setTimeout(function(){
                    var elms = document.querySelectorAll("[id='paginationNumber']");
 
                    for(var i = 0; i < elms.length; i++) {
                        var href = elms[i].href;
                        href.split('pagination=');
                        var newHref = href.split('pagination=')[0] + "pagination=" + pageNumber;
                        elms[i].href = newHref;
                    }
                }, 3000);
                window.history.replaceState("data", "title", "/purchase/history");

                return dispatch({
                    type: actionTypes.FETCH_PURCHASES,
                    history: response[0]
                });
            });
    };
}

function submitFeedbackForCartItem(options, callback) {
    return function (dispatch, getState) {
        const { InvoiceNo, cartId, rating, feedback } = options;
        const info = Object.assign({}, getState().purchaseReducer.detail);
        $.ajax({
            url: `/purchase/detail/${InvoiceNo}/feedback/${cartId}`,
            type: 'POST',
            data: {
                ItemRating: rating,
                Message: feedback
            },
            success: function (result) {
                if (typeof callback === 'function') callback(result);
                if (info.Orders) {
                    info.Orders.map(order => {
                        order.CartItemDetails.map(cartItem => {
                            if (cartItem.ID == cartId) cartItem.Feedback = result.feedback || null;
                        });
                    })
                } else {
                    //b2b
                        info.CartItemDetails.map(cartItem => {
                            if (cartItem.ID == cartId) cartItem.Feedback = result.feedback || null;
                        });

                }

                return dispatch({
                    type: actionTypes.FETCH_DETAIL,
                    detail: info
                });
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.log(textStatus, errorThrown);
            }
        });
    };
}
function updateSelectedOrderStatus(status) {
    return function (dispatch, getState) {
        return dispatch({
            type: actionTypes.UPDATE_SELECTED_ORDER_STATUS,
            selectedOrderStatuses: status
        });
    };
}

function updateSelectedSuppliers(suppliers) {
    return function (dispatch, getState) {
        return dispatch({
            type: actionTypes.UPDATE_SELECTED_SUPPLIERS,
            selectedSuppliers: suppliers
        });
    };
}

function updateSelectedDates(date) {
    return function (dispatch, getState) {
        return dispatch({
            type: actionTypes.UPDATE_SELECTED_DATES_PO,
            selectedDates: {
                StartDate: date.StartDate,
                EndDate: date.EndDate
            }
        });
    };
}

function updateKeyword(keyword) {
    return function (dispatch, getState) {
        return dispatch({
            type: actionTypes.UPDATE_SELECTED_WORD_PO,
            keyword: keyword
        });
    };
}

function updateSelectedCartItemStatus(status) {
    return function (dispatch, getState) {
        return dispatch({
            type: actionTypes.UPDATE_SELECTED_CART_ITEM_ORDER_STATUS,
            selectedCartItemStatus: status
        });
    };
}

module.exports = {
    searchPurchase: searchPurchase,
    goToPage: goToPage,
    goToPageN: goToPageN,
    submitFeedbackForCartItem,
    updateSelectedSuppliers: updateSelectedSuppliers,
    updateSelectedOrderStatus: updateSelectedOrderStatus,
    updateSelectedDates: updateSelectedDates,
    updateKeyword: updateKeyword,
    updateSelectedCartItemStatus: updateSelectedCartItemStatus,
    searchPurchaseFulfilment: searchPurchaseFulfilment,
    goToPageFulfilment: goToPageFulfilment
}